import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    markHandled,
    markHandledSuccess,
    markHandledFailure,
    fetchMissedDossiersCount,
    fetchMissedDossiersCountSuccess,
    fetchMissedDossiersCountFailures,
    retryMissedDossier,
    retryMissedDossierSuccess,
    retryMissedDossierFailure
} from './missed-dossiers.action';
import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { MissedDossiersTableService } from './missed-dossiers-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Injectable()
export class MissedDossiersRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'missed-dossiers';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: data.pagination.total });
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(markHandled),
            exhaustMap((data:any) => {
                const url = 'mark-missed-dossiers/'+data.id;
                return this.crudServerService.updateDataPost(url, {}).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.moduleTableService.loadRecords();
                        return markHandledSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => markHandledFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    retryMissedDossier$ = createEffect(() =>
        this.actions$.pipe(
            ofType(retryMissedDossier),
            exhaustMap((data:any) => {
                const url = 'retry-missed-dossiers/'+data.id;
                return this.crudServerService.updateDataPost(url, {}).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.moduleTableService.loadRecords();
                        return retryMissedDossierSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => retryMissedDossierFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );


    

    fetchMissedDossiersCount$ = createEffect(() =>
            this.actions$.pipe(
                ofType(fetchMissedDossiersCount),
                exhaustMap((data: any) => {
                    const url = 'missed-dossiers-count';
                    return this.crudServerService.fetchData(url).pipe(
                        map( (response: any) => {

                            const count = (response?.data?.count ?? 0);
                            this.localStorageService.setItem("sportlink-missed-dossier-counter", count);
                            const oldCount = this.moduleTableService.sidebarCount;
                            this.moduleTableService.sidebarCount = count;
    
                            if(oldCount !== count && (oldCount != undefined && count))
                                this.moduleTableService.loadRecords(); 
    
                            return fetchMissedDossiersCountSuccess();
                        }),
                        catchError((error) =>
                            of(error).pipe(
                                map(() => fetchMissedDossiersCountFailures({ error }))
                            )
                        )
                    )
                })
            )
        );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: MissedDossiersTableService,
        private tableService: DatatableService,
        public helperService: HelperService,
        private localStorageService: LocalStorageService,
    ) { }

}